import Mutation from './mutationTypes';
import {
    apiGetAccordions,
    apiGetAccordionContent,
    apiGetAccordionFooter,
    apiUpdateAccordionSettings,
    deleteSavedSearch,
    updateSavedSearch,
    deleteFavourite,
    apiGetLawlexRecentSearch,
    apiGetLawlexRegulatoryNewsFeed,
    apiRedirectToLawlexUrl,
    apiAddToIpdLog,
    apiGetEurlexSavedSearch,
    apiRedirectToEurlexUrl
} from "@/components/QuickViews/api"

export default {
    callUpdateSettingsApi: async ({getters}) => {
        await apiUpdateAccordionSettings(getters.getHomeAccordions);
    },
    setAccordionOptions: async ({commit, getters}, {accordion, payload, bulkChange} ) => {
        const hasBulkChange = bulkChange || false;
        getters.getHomeAccordions.forEach(el => {
            if (el.id === accordion) {
                accordion = el
            }
        })
        Object.assign(accordion, payload );
        commit(Mutation.SET_ACCORDION_OPTIONS, {accordion, payload});

        if (!hasBulkChange) {
            await apiUpdateAccordionSettings(getters.getHomeAccordions);
        }

    },
    fetchAccordions: async ({commit}) => {
        try {
            commit(Mutation.SET_LOADING_STATUS, true);
            let accordions = await apiGetAccordions();
            commit(Mutation.SET_HOME_ACCORDIONS, accordions);

              for (const accordion of accordions){
                let accordionName = accordion.id;
                let accordionContent = await apiGetAccordionContent(accordionName);
                if (accordion['footer']) {
                    const accordionFooter = await apiGetAccordionFooter(accordionName);
                    commit(Mutation.SET_ACCORDION_FOOTER,{accordionName,accordionFooter})
                }
                // this condition is temporary and will be removed once user settings for accordion is updated.
                if (accordionName !== 'legislation') {
                    commit(Mutation.SET_ACCORDION_CONTENT,{accordionName,accordionContent})
                }
            }

             commit(Mutation.SET_LOADING_STATUS, false);

        } catch(error) {
            console.log('apiGetAccordions failed.'+ error);
            commit(Mutation.SET_LOADING_STATUS, false);
        }
    },
    fetchLawlexAccordions: async ({commit},{fetchType}) => {
        try {
            commit(Mutation.SET_LAWLEX_LOADING_STATUS, true);
            if(fetchType === 'newsFeeds') {
                let lawlexRegulatoryNewsFeedAccordion = await apiGetLawlexRegulatoryNewsFeed();
                commit(Mutation.SET_LAWLEX_NEWSFEEDS, lawlexRegulatoryNewsFeedAccordion);
            } else if(fetchType === 'recentSearches') {
                let lawlexRecentSearchAccordion = await apiGetLawlexRecentSearch();
                commit(Mutation.SET_LAWLEX_RECENT_SEARCHES, lawlexRecentSearchAccordion);
            } else if(fetchType === 'savedSearches') {
                let eurlexSavedSearchAccordion = await apiGetEurlexSavedSearch();
                commit(Mutation.SET_EURLEX_SAVED_SEARCH, eurlexSavedSearchAccordion);
            }
             commit(Mutation.SET_LAWLEX_LOADING_STATUS, false);

        } catch(error) {
            console.error('apiGetAccordions failed.'+ error);
            commit(Mutation.SET_LAWLEX_LOADING_STATUS, false);
        }
    },

    // Combine redirectToLawlexUrl and redirectToEurlexUrl into a single function
    redirectToUrl: async (context, { url, module, type }) => {
        try {
            if (type === 'lawlexau') {
                await apiRedirectToLawlexUrl(url, module);
            } else if (type === 'lawlexeu') {
                await apiRedirectToEurlexUrl(url, module);
            } else {
                throw new Error('Unknown redirect type');
            }
        } catch (error) {
            console.error('Redirect failed:', error);
        }
    },

    addToIpdLog: async (context, payload) => {
        try {
          const { moduleName, linkClicked } = payload;
          await apiAddToIpdLog(moduleName, linkClicked);
        } catch (error) {
          console.error('Failed to add to Ipd log:', error);
        }
    },
    updateSavedSearch: async ({ commit }, {action, elementId, elementName, elementNotify }) => {
        const name = elementName || '';
        let response = false
        try {
            switch (action) {
                case 'delete':
                    const results = await deleteSavedSearch(elementId);
                    if (results) {
                        await apiGetAccordions();
                        let accordionName = "myActivities";
                        let accordionContent = await apiGetAccordionContent(accordionName);
                        commit(Mutation.SET_ACCORDION_CONTENT,{accordionName,accordionContent})
                        response = true;
                    }
                    break;
                case 'update':
                    const resultsUpdate = await updateSavedSearch(elementId, name, elementNotify);
                    if (resultsUpdate) {
                        await apiGetAccordions();
                        let accordionName = "myActivities";
                        let accordionContent = await apiGetAccordionContent(accordionName);
                        commit(Mutation.SET_ACCORDION_CONTENT,{accordionName,accordionContent})
                        response = true;
                    }
                    break;
            }
        } catch (e) {
            console.log(e);
        }
        return response;
    },
    deleteFavourite: async ({ commit }, {elementId}) => {
        let response = false
        try {
            const results = await deleteFavourite(elementId);
            if (results) {
                await apiGetAccordions();
                let accordionName = "myActivities";
                let accordionContent = await apiGetAccordionContent(accordionName);
                commit(Mutation.SET_ACCORDION_CONTENT,{accordionName,accordionContent})
                response = true;
            }
        } catch (e) {
            console.log(e);
        }
        return response;
    }
}